import { render, staticRenderFns } from "./payUpgrade.vue?vue&type=template&id=6940e68f&scoped=true"
import script from "./payUpgrade.vue?vue&type=script&lang=js"
export * from "./payUpgrade.vue?vue&type=script&lang=js"
import style0 from "./payUpgrade.vue?vue&type=style&index=0&id=6940e68f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940e68f",
  null
  
)

export default component.exports